// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moderation-section {
    max-width: 1400px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-family: sans-serif;
}

.moderation-section h2 {
    text-align: center;
    margin-bottom: 20px;
    color: #333;
}

.moderation-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.moderation-form label {
    font-weight: bold;
    color: #333;
}

.moderation-form input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
}

.moderation-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;
}

.moderation-buttons button {
    padding: 10px 15px;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.moderation-buttons button:hover {
    background-color: #f2f2f2;
}

.moderation-buttons .check {
    background-color: #007bff;
    color: white;
}

.moderation-buttons .check:hover {
    background-color: #0056b3;
}

.moderation-buttons .add {
    background-color: #28a745;
    color: white;
}

.moderation-buttons .add:hover {
    background-color: #218838;
}

.moderation-buttons .delete {
    background-color: #d9534f;
    color: white;
}

.moderation-buttons .delete:hover {
    background-color: #c9302c;
}

@media (max-width: 768px) {
    .moderation-form {
        flex-direction: column;
    }
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.disabled-tab {
    color: #999;
    background-color: #eee;
    border: 1px solid #ccc;
}`, "",{"version":3,"sources":["webpack://./src/Moderation.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;AAC1B","sourcesContent":[".moderation-section {\n    max-width: 1400px;\n    margin: 20px auto;\n    padding: 20px;\n    background: #fff;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    font-family: sans-serif;\n}\n\n.moderation-section h2 {\n    text-align: center;\n    margin-bottom: 20px;\n    color: #333;\n}\n\n.moderation-form {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.moderation-form label {\n    font-weight: bold;\n    color: #333;\n}\n\n.moderation-form input {\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 16px;\n}\n\n.moderation-buttons {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 20px;\n}\n\n.moderation-buttons button {\n    padding: 10px 15px;\n    font-size: 14px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.moderation-buttons button:hover {\n    background-color: #f2f2f2;\n}\n\n.moderation-buttons .check {\n    background-color: #007bff;\n    color: white;\n}\n\n.moderation-buttons .check:hover {\n    background-color: #0056b3;\n}\n\n.moderation-buttons .add {\n    background-color: #28a745;\n    color: white;\n}\n\n.moderation-buttons .add:hover {\n    background-color: #218838;\n}\n\n.moderation-buttons .delete {\n    background-color: #d9534f;\n    color: white;\n}\n\n.moderation-buttons .delete:hover {\n    background-color: #c9302c;\n}\n\n@media (max-width: 768px) {\n    .moderation-form {\n        flex-direction: column;\n    }\n}\n\nbutton:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.disabled-tab {\n    color: #999;\n    background-color: #eee;\n    border: 1px solid #ccc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
